import { render } from "./Leaderboard.vue?vue&type=template&id=52ea79f0"
import script from "./Leaderboard.vue?vue&type=script&lang=js"
export * from "./Leaderboard.vue?vue&type=script&lang=js"

import "./Leaderboard.vue?vue&type=style&index=0&id=52ea79f0&lang=css"
script.render = render

export default script